import {IJournalDecadalDataRow} from './journal.controller';

interface IDischargePair {
  waterLevel: number;
  discharge: number;
}

export class DecadalTableController {
  /**
   * Displayed decadal data.
   */
  decadalData: IJournalDecadalDataRow[];
  /**
   * Monthly average data.
   */
  monthlyAverage: IDischargePair|null;


  $onChanges() {
    this.decadalData = this.decadalData || [];
    if (this.decadalData.length == 0) {
      this.monthlyAverage = null;
      return;
    }
    const accumulatedData: IDischargePair = this.decadalData
        .reduce((previousValue, currentValue) => {
          return {
            waterLevel: previousValue.waterLevel + currentValue.waterLevel,
            discharge: previousValue.discharge + currentValue.discharge
          };
        }, {
          waterLevel: 0,
          discharge: 0
        });
    this.monthlyAverage = {
      waterLevel: Math.round(
          accumulatedData.waterLevel / this.decadalData.length),
      discharge: accumulatedData.discharge / this.decadalData.length
    };
  }
}



/** WEBPACK FOOTER **
 ** ./app/operational/journal/decadal-discharge-table.controller.ts
 **/